<template>
  <div id="grid-ejecucion">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex>
          <br />
          <v-btn
  v-if="
    (usuarioLoggedTipe == 'PROVEEDOR' ||
      usuarioLoggedTipe == 'ADMINISTRADOR') &&
    getCodigoPerfil() != 'LEC' &&
    !isContratoCerrado()
  "
  color="primary"
  dark
  class="mb-2"
  @click="openForm()"
  >Nuevo</v-btn
>
        </v-flex>
        <carga-masiva
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
        ></carga-masiva>
      </v-layout>
      <v-spacer></v-spacer>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="nivelValue"
            item-text="nombre"
            item-value="code"
            :items="nivelSelect"
            label="Nivel"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4> </v-flex>
        <v-flex xs12 md4> </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="filterGrid()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <!-- BOTON NO INCLUIDO EN DISEÑO DEBERIA ESTAR -->
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsRegistro"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.idRegion.nombre }}</td>
              <td class="text-xs-left">{{ props.item.idCentro.codCentro }}</td>
              <td class="text-xs-left">
                {{ props.item.idSalCurso.codBarraContenedora }}
              </td>
              <td class="text-xs-left">{{ props.item.idSalCurso.rbd }}</td>
              <td class="text-xs-left">
                {{ props.item.idSalCurso.codigoCurso }}
              </td>
              <td class="text-xs-left">{{ props.item.fecha_entrega }}</td>
              <td class="text-xs-left">{{ props.item.observaciones }}</td>
              <td v-if="tipeView == 'oculto'">
                <div class="text-xs-center">
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Consultar detalle"
                    @click="viewForm(props.item.id)"
                    ><v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </div>
              </td>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <!-- <td>
                <template>
                  <v-btn
                    class="btn-sigas" depressed outline icon fab dark 
                    color="green darken-4"
                    small
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>Consultar detalle
                </template>
              </td>-->
            </div>
          </v-card-actions>
          <!--fin iconos leyenda-->
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="primary"
          dark
          class="mb-2"
          @click="downloadComplete()"
          >Descarga Completa <v-icon right dark>folder</v-icon></v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";
import CargaMasiva from "@/components/CargaMasiva.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-ejecucion",
  components: {
    Loading,
    CargaMasiva,
  },
  mixins: [misMixins],
  props: {
    rowsTable: "",
    tipeView: "",
  },

  data() {
    return {
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      botonValida: 1,
      loading: false,
      itemsRegistro: [],
      dialogValidation: false,
      dialog: false,
      resp: "",
      contratoId: "",
      itemsProgreso: [],
      headers: [
        { text: "Region", align: "left", sortable: false, value: "region" },
        { text: "Centro Origen", sortable: false, value: "centroAcopio" },
        {
          text: "IdCodBarraContenedora",
          sortable: false,
          value: "idCodBarraContenedora",
        },
        { text: "RBD", sortable: false, value: "rbd" },
        { text: "CodigoCurso", sortable: false, value: "codigoCurso" },
        { text: "Fecha Real", sortable: false, value: "fecha" },
        { text: "Observaciones", sortable: false, value: "Observaciones" },
      ],
      fechaInicioValue: [],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsMateriales: [],
      centroAcopio: "",
      nivelValue: null,
      nivelSelect: [],
      tipoMaterialValue: null,
      tipoMaterialSelect: [],
      regionValue: null,
      regionesSelect: [],
      fechaValue: null,
      fechaSelect: [],
      resultadoValue: null,
      resultadoSelect: [],
      filter: false,
      tabSelected: "",
      tipeArchive: "",
      filex: "",
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
    };
  },
  created() {
    this.loading = true;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.tabSelected = this.$store.getters.subTabSelectedStored;
    //se indican las apis a utilizar
    this.apiValidateDocument = "/traspasoCaptura/preProcessNewTraspasoCaptura";
    this.apiSaveDocument = "/traspasoCaptura/GuardarTraspasoCapturaMasivo";
    this.apiDownloadDocument =
      "/traspasoCaptura/downloadPlantillaTraspasoCaptura/";
    this.templateTitle = "Planilla_Traspaso_Captura_Ejecucion";
    this.loadData();
  },
  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    openForm(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormEjecucionCaptura",
          params: {
            idTraspaso: id,
            tipeView: "crear",
            titleView: "Nueva Ejecucion",
          },
        });
      }, 1000);
    },

    async loadResgistroFilter() {
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        idNivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        idContrato: idContrato,
      };
      return await axios
        .post("/traspasoCaptura/getAllFilterTraspasoCaptura", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsRegistro = await this.loadResgistroFilter();
      this.miPaginacion.totalItems = this.itemsRegistro.length;
      this.loading = false;
      if (this.itemsRegistro.length > 0) {
        this.loadNivelSelect();
      }
    },

    loadNivelSelect() {
      let com = [];
      this.itemsRegistro.forEach(function (c) {
        com.push({
          nombre: c.idSalCurso.nivel,
          code: c.idSalCurso.idNivel,
        });
      });
      this.nivelSelect = com;
      this.nivelValue = "";
    },

    clear() {
      this.nivelValue = "";
      this.loadData();
    },
    //SOLO NUMEROS
    bloqueoEdicion(tip) {
      if (tip == "AGENCIA") {
        this.bloqueo = true;
      }
      if (tip == "PROVEEDOR") {
        this.bloqueo = false;
      }
      return this.bloqueo;
    },

    filterGrid() {
      this.filter = true;
      this.loadData();
    },

    downloadComplete() {
      let idContrato = this.$store.getters.contratoStored;
      let fileName = "Registro_Captura_Ejecucion.xlsx";
      this.body = {
        idContrato: idContrato,
      };
      axios
        .post("/traspasoCaptura/writeObjectToExcelTraspasoMasivo", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>